import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';

import { makeStyles } from '@material-ui/core/styles';
import { founder } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(5),
    boxShadow: 'none'
  },
  section: {
    padding: '5rem 0',
    backgroundColor: 'white'
  },
}));

const Preface = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        alignItems="center"
        className={classes.section}
        component="header"
        container
        justify="center"
      >
        <Grid
          item
          md={5}
          sm={12}
          xs={12}
        >
          <Paper
            className={classes.paper}
          >
            <Typography variant="h1">
              Le Studio
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              SoFenua est studio de jeu vidéo indépendant. Notre crédo : jouons à sauver le monde pour de vrai !
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Notre objectif est de démontrer que le plaisir a une place importante dans la lutte contre le changement climatique et le bien-être de notre planète.
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Grâce aux revenus publicitaires ou à l'achat de contenu virtuel, vous soutenez les associations qui plantent des arbres.
            </Typography>
          </Paper>
        </Grid>
        <Grid
          item
          lg={3}
          md={4}
          sm={8}
          xs={12}
        >
          <Paper className={classes.paper}>
            <CardActionArea>
              <CardMedia
                alt={founder.alt}
                className={classes.media}
                component="video"
                controls
                image={founder.video}
                object-fit
                style={{borderRadius: '5px'}}
                title={founder.title}
              />
            </CardActionArea>
            <Typography
              align="center"
              component="p"
              style={{marginTop: '0.5rem'}}
              variant="subtitle2"
            >
              Le créateur de SeedOut nous explique le concept du jeu en 2 minutes !
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default Preface;
